import TableNew, { CELL_TYPES } from "../../../../shared/Table";

const AmlDepositsTableComponent = ({ data }) => {
  const columns = [
    {
      key: "Created",
      label: "Deposit Date",
      visible: true,
      type: CELL_TYPES.date,
    },
    {
      key: "InvestorDepositDetails.Amount",
      label: "Amount",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "InvestorDepositDetails.Currency",
      label: "Currency",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "InvestorDepositDetails.UniqueRef",
      label: "UniqueRef",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "Trigger",
      label: "AML Trigger",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "SendBackOrder",
      label: "Sent Back Date",
      visible: true,
      type: CELL_TYPES.date,
      renderer: (value) => {
        return <div>{value?.Executed ?? "Not sent yet"}</div>;
      },
    },
    {
      key: "SendBackOrder",
      label: "Send Back Order Id",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <div>{value?.Id}</div>;
      },
    },
    {
      key: "SendBackOrder",
      label: "Send Back Note",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <div>{value?.Notes}</div>;
      },
    },
    {
      key: "SendBackOrder",
      label: "Bank Account Sent Back To",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <div>{value?.BankAccountNumber}</div>;
      },
    },
    {
      key: "SendBackOrder",
      label: "Bank Name",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <div>{value?.BankName}</div>;
      },
    },
    {
      key: "Notes",
      label: "Aml Note",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <div>{value && FindNewestNote(value)}</div>;
      },
    },
  ];

  function FindNewestNote(value) {
    const table = [...value];
    return table.sort((a, b) => new Date(a.Created) - new Date(b.Created))[
      value.length - 1
    ]?.Note;
  }

  return (
    <TableNew columns={columns} tableKey={"amlDepositsTable"} items={data} />
  );
};

export default AmlDepositsTableComponent;
